import React from "react";
import { Bar } from "react-chartjs-2";
import styles from "../styles/homeStyle"
import BottomBar from "./BottomBar";

import {
  Chart as ChartJS,
  CategoryScale,
  LinearScale,
  BarElement,
  Title,
  Tooltip,
  Legend,
} from "chart.js";

ChartJS.register(CategoryScale, LinearScale, BarElement, Title, Tooltip, Legend);

function Home() {
  const [isMenuOpen, setIsMenuOpen] = React.useState(false);

  const toggleMenu = () => {
    setIsMenuOpen(!isMenuOpen);
  };

  const highlights = [
    { label: "Laba Berjalan", value: "Rp 1.000.000.000" },
    { label: "Total Pendapatan", value: "Rp 1.100.000.000" },
    { label: "Total Beban", value: "Rp 100.000.000" },
    { label: "Total Hutang Berjalan", value: "Rp 100.000.000" },
    { label: "Total Laba Ditahan 2024", value: "Rp 100.000.000" },
  ];

  const chartData = {
    labels: ["Januari", "Februari", "Maret", "April", "Mei", "Juni"],
    datasets: [
      {
        label: "Penjualan",
        data: [150, 200, 100, 300, 250, 400],
        backgroundColor: "rgba(75, 192, 192, 0.6)",
      },
    ],
  };

  const chartOptions = {
    responsive: true,
    plugins: {
      legend: {
        position: "bottom",
      },
      title: {
        display: false,
        text: "Performa Keuangan",
      },
    },
  };

  return (
    <div style={styles.container}>
      {/* SIDEBAR */}
      <div
        style={{
          ...styles.sidebar,
          transform: isMenuOpen ? "translateX(0)" : "translateX(100%)",
        }}
      >
        <h3>Menu</h3>
        <button onClick={toggleMenu} style={styles.closeButton}>
          Tutup
        </button>
        <ul style={{ listStyle: "none", padding: 0 }}>
          <li>Dashboard</li>
          <li>Profile</li>
          <li>Settings</li>
          <li>Logout</li>
        </ul>
      </div>

      <div style={styles.content}>
        {/* HEADER */}
        <header style={styles.header}>
          <div>
            <h2>Welcome, alen</h2>
            <h4>Highlight Per Juni 2024</h4>
          </div>
          {/* Tombol Hamburger */}
          <div style={styles.menuButton} onClick={toggleMenu}>
            <div style={styles.menuBar}></div>
            <div style={styles.menuBar}></div>
            <div style={styles.menuBar}></div>
          </div>
        </header>

        {/* HIGHLIGHTS */}
        <div style={styles.highlightContainer}>
          {highlights.map((item, index) => (
            <div key={index} style={styles.highlightBox}>
              <h3 style={{ margin: 0 }}>{item.value}</h3>
              <p style={{ margin: 0 }}>{item.label}</p>
            </div>
          ))}
        </div>

        {/* CHARTS */}
        <div style={styles.chartSection}>
          <h4>Performa Keuangan</h4>
          <div style={styles.chartWrapper}>
            <Bar data={chartData} options={chartOptions} />
          </div>
        </div>

        <div style={styles.chartSection}>
          <h4>Performa Penjualan Kios</h4>
          <div style={styles.chartWrapper}>
            <Bar data={chartData} options={chartOptions} />
          </div>
        </div>

        <div style={styles.chartSection}>
          <h4>Performa Penjualan Tiket</h4>
          <div style={styles.chartWrapper}>
            <Bar data={chartData} options={chartOptions} />
          </div>
        </div>

        <div style={styles.chartSection}>
          <h4>Performa Penjualan Barang</h4>
          <div style={styles.chartWrapper}>
            <Bar data={chartData} options={chartOptions} />
          </div>
        </div>

        <BottomBar/>


      </div>
    </div>
  );
}

export default Home;
